import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { OktaConfig } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

import { environment } from 'src/environments/environment';

export function onAuthRequiredFunction(oktaAuth: OktaAuth, injector: Injector) {
  const router = injector.get(Router);
  // Redirect the user to the custom login page
  if (environment.authLoginInternal) {
    router.navigate(['/login']);
  }/* else {
    const path = oktaAuth.getFromUri();
    oktaAuth.loginRedirect(path.uri);
  }*/
}

const oktaAuth = new OktaAuth({
  issuer: environment.okta_issuer,
  clientId: environment.okta_client_id,
  redirectUri: environment.okta_redirectUri,
  pkce: true,
  scopes: [environment.okta_scope],
  postLogoutRedirectUri: window.location.origin + '/login'
});

export const oktaConfig: OktaConfig = {
  oktaAuth,
  onAuthRequired: onAuthRequiredFunction,
};
